import {OrderProtocol, orderProtocolDecoder} from './OrderProtocol'
import {
    OrderProtocolDetail,
    orderProtocolDetailDecoder
} from './OrderProtocolDetail'
import {array, Decoder, field, object} from 'json-bouncer'

export interface OrderProtocolWithDetails {
    orderProtocol: OrderProtocol
    orderProtocolDetails: OrderProtocolDetail[]
}

export function orderProtocolWithDetailsDecoder(): Decoder<OrderProtocolWithDetails> {
    return object({
        orderProtocol: field('orderProtocol', orderProtocolDecoder()),
        orderProtocolDetails: field('orderProtocolDetails', array(orderProtocolDetailDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderProtocolWithDetails.ts